import { computed, toValue, type MaybeRefOrGetter } from 'vue'
import type { FieldEntityTarget, StakeholderType } from '@gat-ship/types'
import { stakeholderTypeToTarget } from '../model/stakeholder-type-target'

/**
 * Resolve the custom-field entity target for a stakeholder type. The blessed
 * `composables/` indirection so components/views don't value-import `model/`.
 */
export function useStakeholderTarget(
  stakeholderType: MaybeRefOrGetter<StakeholderType | undefined>
) {
  return computed<FieldEntityTarget>(
    () => stakeholderTypeToTarget[toValue(stakeholderType) ?? 'client']
  )
}
